export const secondFormat = num => {
  if (!num) return '00:00:00'
  let hour = Math.floor(num / 3600)
  let mimute = Math.floor((num - hour * 3600) / 60)
  let second = num - hour * 3600 - mimute * 60
  hour = hour < 10 ? '0' + hour : hour
  mimute = mimute < 10 ? '0' + mimute : mimute
  second = second < 10 ? '0' + second : second
  return hour + ':' + mimute + ':' + second
}
